<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading"></app-mat-spinner-overlay>
<div class="dialog-container">
  <div class="dialog-header">
    <mat-icon>search</mat-icon>
    <h2 mat-dialog-title>Pesquisa de Redes</h2>
    <button mat-icon-button [mat-dialog-close]="grupoSelecionado" class="close-button" matTooltip="Fechar diálogo">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="dialog-content">
    <div class="search-form-container">
      <form autocomplete="off">
        <div class="search-form-row">
          <div class="form-fields">
            <mat-grid-list cols="12" rowHeight="100px">
              <mat-grid-tile colspan="3" rowspan="1">
                <mat-form-field>
                  <mat-label>Selecionar Por</mat-label>
                  <mat-select [(ngModel)]="filtro.coluna" name="coluna">
                    <mat-option *ngFor="let opcao of selectUm" [value]="opcao.value">
                      {{opcao.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

              </mat-grid-tile>
              <mat-grid-tile colspan="3" rowspan="1">

                <mat-form-field>
                  <mat-select [(ngModel)]="filtro.operador" name="operador">
                    <mat-option *ngFor="let opcaosec of selectDois" [value]="opcaosec.value">
                      {{opcaosec.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile colspan="5" rowspan="1">

                <mat-form-field>
                  <input matInput placeholder="" [(ngModel)]="filtro.parametro" maxlength="50"
                    [value]="filtro.parametro">
                  <mat-icon (click)="limpaFiltro()" aria-hidden="false"
                    aria-label="Limpe o resultado da pesquisa de Frota" fontIcon="delete">
                  </mat-icon>
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile colspan="1" rowspan="1">

                <button mat-flat-button color="accent" type="button" (click)="filtrarTabela()"
                  [disabled]='!filtro.parametro' mat-icon-button style="margin-left: 10px"
                  matTooltip="Pesquise a Frota">
                  <mat-icon aria-hidden="false" aria-label="Pesquise a Frota" fontIcon="search"></mat-icon>
                </button>

              </mat-grid-tile>
            </mat-grid-list>
          </div>
        </div>
      </form>
    </div>

    <div>
      <h4><strong>Selecione abaixo a entidade desejada</strong></h4>
      <table mat-table [dataSource]="items" matSort matSortActive="codGrupo" class="w-100">

            <ng-container matColumnDef="codigoGrupo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Ordenar por código">
                Código do Grupo
              </th>
              <td mat-cell *matCellDef="let element">{{element.codigoGrupo}}</td>
            </ng-container>
            <ng-container matColumnDef="descricaoGrupo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Ordenar por nome descrição">
                Descrição do Grupo
              </th>
              <td mat-cell *matCellDef="let element" class="descricao-coluna">{{element.descricaoGrupo}}</td>
            </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row (click)="gerenciarSelect(row)" *matRowDef="let row; columns: displayedColumns; let even = even"
          class="table-row"></tr>
      </table>


      <tr class="no-data" *ngIf="items.data.length == 0 && !loading">
        <td colspan="3" style="text-align: center; font-weight: bold;">
          Nenhum grupo foi encontrado!
        </td>
      </tr>
      <tr class="no-data" *ngIf="loading">
        <td colspan="3" style="text-align: center; font-weight: bold;">
          Aguarde, consultando grupos...
        </td>
      </tr>
    </div>

    <div>
      <div class="paginator-centre">
        <mat-paginator [pageSizeOptions]="[10,15,25]" showFirstLastButtons class="mat-elevation-z8"
          aria-label="Selecione a página dos grupos">
        </mat-paginator>
      </div>
    </div>
  </div>


</div>